/**
 * 旅行回忆系统 - 权限检查工具
 * 检查用户是否有travelMemories模块权限
 */

/**
 * 检查用户是否有旅行回忆系统权限
 * @returns {Promise<boolean>} 是否有权限
 */
export const hasTravelMemoriesPermission = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }

    // 从localStorage获取用户信息
    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return false;
    }

    const user = JSON.parse(userStr);

    // 系统管理员自动拥有所有权限
    if (user.isAdmin) {
      return true;
    }

    // 这里可以添加更详细的权限检查
    // 目前先检查是否有token，后续可以通过API验证权限
    return true;
  } catch (error) {
    console.error('检查旅行回忆系统权限失败:', error);
    return false;
  }
};

/**
 * 检查用户是否有特定操作权限
 * @param {string} action - 操作类型 (view, create, update, delete)
 * @returns {Promise<boolean>} 是否有权限
 */
export const hasTravelMemoriesActionPermission = async (action) => {
  try {
    const hasPermission = await hasTravelMemoriesPermission();
    if (!hasPermission) {
      return false;
    }

    const userStr = localStorage.getItem('user');
    if (!userStr) {
      return false;
    }

    const user = JSON.parse(userStr);

    // 系统管理员自动拥有所有权限
    if (user.isAdmin) {
      return true;
    }

    // 这里可以添加更详细的权限检查
    // 目前先返回true，后续可以通过API验证权限
    return true;
  } catch (error) {
    console.error('检查操作权限失败:', error);
    return false;
  }
};
